import Queries from '../../../utils/API/Queries';
import { setSelectedRegion } from '../../../redux/store/user/actions';
import { showErrorMessage, showSuccessMessage } from '../../../redux/store/Control';

class UIPartnerPackageHelper {
	static deleteSelectedPackage = async (packageToDelete, currentUser, partner, setPackageToDelete) => {
		if (packageToDelete) {
			const { partners: partnersArray = [] } = currentUser.selectedRegion.regionConfig.coldwellPackages;
			const unchangedPartners = partnersArray.filter((filterPartner) => filterPartner.name !== partner.name);
			let matchingPartner = partnersArray.filter((filterPartner) => filterPartner.name === partner.name)[0];
			const unchangedPartnerPackage = matchingPartner.packages.filter((filterPackage) => filterPackage.name !== packageToDelete.name);
			matchingPartner.packages = [...unchangedPartnerPackage];

			const partners = [...unchangedPartners, matchingPartner];
			let variables = {
				id: currentUser.selectedRegion.regionConfig.id,
				coldwellPackages: {
					...currentUser.selectedRegion.regionConfig.coldwellPackages,
					partners
				}
			};
			const response = await props.client
				.mutate({
					mutation: Queries.UPDATE_REGION_CONFIG,
					variables
				})
				.catch((error) => {
					showErrorMessage(error.message);
				});
			const { updateRegionConfig } = response['data'];
			if (updateRegionConfig) {
				currentUser.selectedRegion.regionConfig = updateRegionConfig;
				setSelectedRegion(currentUser.selectedRegion);
				setPackageToDelete(undefined);
				showSuccessMessage('Deleted package!');
			} else {
				showErrorMessage('Error updating packages!');
			}
		}
	};
}

export default UIPartnerPackageHelper;
